const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://africa-space-agency-api.onrender.com/api/v1/'
const API_KEY = import.meta.env.VITE_API_KEY || ''


let authToken: string | null = null

export function getAuthToken(): string | null {
 
  authToken = sessionStorage.getItem('auth_token')
  return authToken
}

export function setAuthToken(token: string): void {
  authToken = token
  sessionStorage.setItem('auth_token', token)
}

export function clearAuthToken(): void {
  authToken = null
  sessionStorage.removeItem('auth_token')
}


export async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Api-Key': API_KEY,
    ...(options.headers as Record<string, string>),
  }

  
  const token = getAuthToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const config: RequestInit = {
    ...options,
    headers,
  }

  const response = await fetch(url, config)

  if (!response.ok) {
    let errorText = ''
    try {
      const errorData = await response.json()
      errorText = errorData?.message || errorData?.error || JSON.stringify(errorData)
    } catch {
      try {
        errorText = await response.text()
      } catch {
        errorText = response.statusText
      }
    }

    if (response.status === 401) {
      // For login endpoints, preserve the actual error message
      // For other endpoints, clear token but still preserve message
      const isLoginEndpoint = endpoint.includes('authenticate') || endpoint.includes('login')
      if (!isLoginEndpoint) {
        clearAuthToken()
      }
      // Include the actual error message from API so it can be properly mapped
      throw new Error(` ${response.statusText}. ${errorText || 'Unauthorized'}`)
    }
    if (response.status === 403) {
      throw new Error(`${errorText || response.statusText}`)
    }
    throw new Error(`${response.status} ${response.statusText}. ${errorText}`)
  }

  return response.json()
}


export async function get<T>(endpoint: string): Promise<T> {
  return apiRequest<T>(endpoint, { method: 'GET' })
}

export async function post<T>(endpoint: string, data?: unknown): Promise<T> {
  return apiRequest<T>(endpoint, {
    method: 'POST',
    body: data ? JSON.stringify(data) : undefined,
  })
}

export async function put<T>(endpoint: string, data?: unknown): Promise<T> {
  return apiRequest<T>(endpoint, {
    method: 'PUT',
    body: data ? JSON.stringify(data) : undefined,
  })
}

export async function patch<T>(endpoint: string, data?: unknown): Promise<T> {
  return apiRequest<T>(endpoint, {
    method: 'PATCH',
    body: data ? JSON.stringify(data) : undefined,
  })
}

export async function del<T>(endpoint: string): Promise<T> {
  return apiRequest<T>(endpoint, { method: 'DELETE' })
}


export async function delFormData<T>(endpoint: string, formData: FormData): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`

  const headers: Record<string, string> = {
    'X-Api-Key': API_KEY,
  }


  const token = getAuthToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    body: formData
  })

  if (!response.ok) {
    let errorText = ''
    try {
      const errorData = await response.json()
      errorText = errorData?.message || errorData?.error || JSON.stringify(errorData)
    } catch {
      try {
        errorText = await response.text()
      } catch {
        errorText = response.statusText
      }
    }

    if (response.status === 401) {
      // For login endpoints, preserve the actual error message
      // For other endpoints, clear token but still preserve message
      const isLoginEndpoint = endpoint.includes('authenticate') || endpoint.includes('login')
      if (!isLoginEndpoint) {
        clearAuthToken()
      }
      // Include the actual error message from API so it can be properly mapped
      throw new Error(` ${response.statusText}. ${errorText || 'Unauthorized'}`)
    }
    if (response.status === 403) {
      throw new Error(`${errorText || response.statusText}`)
    }
    throw new Error(`${response.status} ${response.statusText}. ${errorText}`)
  }

  return response.json()
}

export async function postFormData<T>(endpoint: string, formData: FormData): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`

  const headers: Record<string, string> = {
    'X-Api-Key': API_KEY,
    
  }

 
  const token = getAuthToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: formData
  })

  if (!response.ok) {
    let errorText = ''
    try {
      const errorData = await response.json()
      errorText = errorData?.message || errorData?.error || JSON.stringify(errorData)
    } catch {
      try {
        errorText = await response.text()
      } catch {
        errorText = response.statusText
      }
    }

    if (response.status === 401) {
      // For login endpoints, preserve the actual error message
      // For other endpoints, clear token but still preserve message
      const isLoginEndpoint = endpoint.includes('authenticate') || endpoint.includes('login')
      if (!isLoginEndpoint) {
        clearAuthToken()
      }
      // Include the actual error message from API so it can be properly mapped
      throw new Error(` ${response.statusText}. ${errorText || 'Unauthorized'}`)
    }
    if (response.status === 403) {
      throw new Error(`${errorText || response.statusText}`)
    }
    throw new Error(`${response.status} ${response.statusText}. ${errorText}`)
  }

  return response.json()
}


export async function putFormData<T>(endpoint: string, formData: FormData): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`

  const headers: Record<string, string> = {
    'X-Api-Key': API_KEY,
    
  }

  
  const token = getAuthToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: formData
  })

  if (!response.ok) {
    let errorText = ''
    try {
      const errorData = await response.json()
      errorText = errorData?.message || errorData?.error || JSON.stringify(errorData)
    } catch {
      try {
        errorText = await response.text()
      } catch {
        errorText = response.statusText
      }
    }

    if (response.status === 401) {
      // For login endpoints, preserve the actual error message
      // For other endpoints, clear token but still preserve message
      const isLoginEndpoint = endpoint.includes('authenticate') || endpoint.includes('login')
      if (!isLoginEndpoint) {
        clearAuthToken()
      }
      // Include the actual error message from API so it can be properly mapped
      throw new Error(` ${response.statusText}. ${errorText || 'Unauthorized'}`)
    }
    if (response.status === 403) {
      throw new Error(`${errorText || response.statusText}`)
    }
    throw new Error(`${response.status} ${response.statusText}. ${errorText}`)
  }

  return response.json()
}